import { countryFromPath } from '../constants/routes';

type Input = {
  pathname: string;
  search: string;
};

// Only the country goes to Eppo; testers are targeted by their visitor id, the subject of the lookup.
export function buildFlagAttributes(input: Input): Record<string, string> {
  const country = countryFromPath(input.pathname);
  return country ? { country_iso: country } : {};
}
